import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import PageMenu from '../../../blocks/PageMenu/PageMenu';
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";

import useGetRiesgoEmbarazoLactanciaByID from "services/record/RiesgoEmbarazoLactancia/useGetRiesgoEmbarazoLactanciaByID";
import useGetInfoRiesgoEmbarazoLactancia from "services/record/RiesgoEmbarazoLactancia/useGetInfoRiesgoEmbarazoLactancia";
import useGetRiesgoEmbarazoLactanciaByUser from "services/record/RiesgoEmbarazoLactancia/useGetRiesgoEmbarazoLactanciaByUser";

import useDecode from "hooks/useDecode";

import ManagementFormCardList from 'components/blocks/ManagementNewForms/CardList/ManagementFormCardList';

import Loader from "components/blocks/Loader/Loader";
import ErrorDisplay from "components/blocks/ManagementNewForms/ErrorManagement/ErrorPantalla";
import SolicitudRiesgoEmbarazoLactancia from "./SolicitudRiesgoEmbarazoLactancia";

const GridSolicitudRiesgoEmbarazoLactancia = ({ expedienteId = null, origen = null }) => {

    const {
        getRiesgoEmbarazoLactanciaByID,
        loadingGetRiesgoEmbarazoLactanciaByID,
        statusGetRiesgoEmbarazoLactanciaByID
    } = useGetRiesgoEmbarazoLactanciaByID();

    const {
        getInfoRiesgoEmbarazoLactancia,
        loadingGetInfoRiesgoEmbarazoLactancia,
        statusGetInfoRiesgoEmbarazoLactancia
    } = useGetInfoRiesgoEmbarazoLactancia();

    const {
        dataGetRiesgoEmbarazoLactanciaByUser,
        getRiesgoEmbarazoLactanciaByUser,
        loadingGetRiesgoEmbarazoLactanciaByUser,
        statusGetRiesgoEmbarazoLactanciaByUser
    } = useGetRiesgoEmbarazoLactanciaByUser();

    const [currentHttp, setCurrentHttp] = useState({
        status: null,
        statusText: null
    });

    const title = "Solicitud de Riesgo de Embarazo y Lactancia";
    const navigate = useNavigate();

    const tokenResponse = useDecode("token");
    const userId = tokenResponse?.extension_id;
    
    const expedienteIdByOrigen = Number(origen) === 1 ? (expedienteId ?? null) : null;
    const dataUserWithExpedienteByOrigen = (data) => (expedienteIdByOrigen !== null && expedienteIdByOrigen !== undefined ? { ...data, ExpedienteId: expedienteIdByOrigen } : data);

    const [dataUser, setDataUser] = useState<any>(null);
    const [info, setInfo] = useState(false);
    const [showGenerateButton, setShowGenerateButton] = useState(true);
    const [formRenderKey, setFormRenderKey] = useState(0);
    const [generateKey, setGenerateKey] = useState(0);
    const activeRequestRef = useRef(0);
    useEffect(() => {
        getRiesgoEmbarazoLactanciaByUser(userId, expedienteIdByOrigen);
    }, []);

    useEffect(() => {
        if (statusGetRiesgoEmbarazoLactanciaByID?.status) {
            setCurrentHttp({
                status: statusGetRiesgoEmbarazoLactanciaByID.status,
                statusText: statusGetRiesgoEmbarazoLactanciaByID.statusText
            });
        } else if (statusGetInfoRiesgoEmbarazoLactancia?.status) {
            setCurrentHttp({
                status: statusGetInfoRiesgoEmbarazoLactancia.status,
                statusText: statusGetInfoRiesgoEmbarazoLactancia.statusText
            });
        } else if (statusGetRiesgoEmbarazoLactanciaByUser?.status) {
            setCurrentHttp({
                status: statusGetRiesgoEmbarazoLactanciaByUser.status,
                statusText: statusGetRiesgoEmbarazoLactanciaByUser.statusText
            });
        }
    }, [
        statusGetRiesgoEmbarazoLactanciaByID,
        statusGetInfoRiesgoEmbarazoLactancia,
        statusGetRiesgoEmbarazoLactanciaByUser
    ]);

    const rowSelected = (args: any) => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setDataUser(null);
        setInfo(false);
        getRiesgoEmbarazoLactanciaByID(
            args.data.UsuarioId,
            args.data.PrestacionId,
            args.data.Id,
            (data) => {
                if (activeRequestRef.current === requestId) {
                    setDataUser(dataUserWithExpedienteByOrigen(data));
                }
            }
        );
    };

    const handleInfo = async () => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setGenerateKey(prev => prev + 1);
        setDataUser(null);
        setInfo(true);
        await getInfoRiesgoEmbarazoLactancia(userId, (data) => {
            if (activeRequestRef.current === requestId) {
                setDataUser(dataUserWithExpedienteByOrigen(data));
            }
        });
    };

    useEffect(() => {
        const arrData = dataGetRiesgoEmbarazoLactanciaByUser;

        if (arrData && Array.isArray(arrData)) {
            const hasFormZero = arrData.some(item => item.EstadoFormulario === 1 || item.EstadoFormulario === 3);
            setShowGenerateButton(!hasFormZero);
        }
    }, [dataGetRiesgoEmbarazoLactanciaByUser]);

    const isLoading = () => {
        return (
            loadingGetRiesgoEmbarazoLactanciaByID ||
            loadingGetInfoRiesgoEmbarazoLactancia ||
            (loadingGetRiesgoEmbarazoLactanciaByUser && !dataUser)
        );
    };

    return (
        <div className="container bg-#EEEEEE management-new-forms-typography">
            <PageMenu title={title}>
                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>

            <div className="container">
                <ManagementFormCardList dataSource={dataGetRiesgoEmbarazoLactanciaByUser || []} onSelect={rowSelected} key={generateKey} />
            </div>

            {showGenerateButton && (
                <div className="container">
                    <div className="delta-buttons c-right">
                    <button className="btn-box btn-accent" onClick={handleInfo}>
                        Generar Formulario
                    </button>
                    </div>
                </div>
            )}

            <Loader activeLoader={isLoading()} label="Cargando Formulario" />

            {dataUser && (currentHttp.status === 200 || currentHttp.status === 204) && (
                <div className="mt-5">
                    <SolicitudRiesgoEmbarazoLactancia
                        key={[info ? 'create' : 'edit', dataUser?.Id ?? 'new', formRenderKey].join('-')}
                        dataUser={dataUser}
                        info={info}
                        onSuccess={() => getRiesgoEmbarazoLactanciaByUser(userId, expedienteIdByOrigen)}
                    />
                </div>
            )}

            {currentHttp.status && !isLoading() && ![200, 204].includes(currentHttp.status) && (
                <ErrorDisplay descripcionError={currentHttp.statusText} />
            )}
        </div>
    );
};

export default GridSolicitudRiesgoEmbarazoLactancia;




